export default "__VITE_ASSET__2cff969e__"